export default __webpack_public_path__ + "static/media/image6.37937290.png";